export const tableConfig = {
    selection: false,
    height: 357,
    columns: [
        {
            label: '合同编码',
            prop: 'contractCode',
            minWidth: 120
        },
        {
            label: '合同状态',
            prop: 'contractStatus',
            type: 'select',
            optionsKey: 'SYS_CR_CONTRACT_STATUS',
            minWidth: 90
        },
        {
            label: '合同性质',
            prop: 'contractCharacter',
            type: 'select',
            optionsKey: 'SYS_WM_CONTRACT_CHARACTER',
            minWidth: 90
        },
        {
            label: '业务类型',
            prop: 'businessTypeCn',
            minWidth: 140
        },
        {
            label: '生效日期',
            prop: 'validTime',
            minWidth: 120
        },
        {
            label: '失效日期',
            prop: 'failTime',
            minWidth: 120
        },
        {
            label: '创建人',
            prop: 'createUserCode',
            minWidth: 100
        },
        {
            label: '创建时间',
            prop: 'createTime',
            minWidth: 160
        },
        {
            label: '修改人',
            prop: 'updateUserCode',
            minWidth: 100
        },
        {
            label: '修改时间',
            prop: 'updateTime',
            minWidth: 160
        }
    ]
};
